import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'units',
    templateUrl: './units.component.html',
    styleUrls: ['./units.component.scss']
})
export class UnitsComponent extends AdDefaults implements OnInit {

    @Input() type : any = 'default';
    @Input() blockSel : any = 'all';
    @Input() info : any;
    @Input() plain : any = false;
    @Input() swiperConfig : any;
    @Input() title : any = 'Unidades';

    swiperConfigMenu: any = {
        init: true,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    };

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }

    ngOnInit(){
        super.ngOnInit();
        if(this.info?.imagesUnits?.length==1)
        this.swiperConfig.slidesPerView = 1;
    }

}